



































































































































































































































































































































































































































































































































































import { Component, Mixins, Provide, Prop, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { Severity } from '@sentry/types';

@Component({
  components: {
    ElementUpdateSolesSelectSation: () => import('@/components/elements/dfu/ElementUpdateSolesSelectSation.vue'),
  },
})
export default class ElementUpdateSoles extends Mixins(MixinDialog) {
  @Prop({ default: null }) selectedStationID!: string | null;

  @Provide() selectedStation: any = null; // selected Station
  @Provide() checkedSoles: any = []; // All soles which are checking
  @Provide() checkedSolesLength: number = 0;
  @Provide() updateSolesList: any = [];
  // @Provide() calibrateSolesList: any = [];

  @Provide() delay: number = 0;
  @Provide() timer: number = 0;

  // Statuts
  @Provide() step: number = 0;
  @Provide() dialog: boolean = false;
  @Provide() loading: boolean = false;
  @Provide() doneComplete: boolean = false;
  @Provide() commandInProgress: boolean = false;
  @Provide() collectiveCommandInProgress: boolean = false;
  @Provide() pendingCheckBattery: boolean = false;
  @Provide() disconnectedStation: boolean = false;
  // @Provide() startCalibration: boolean = false;
  @Provide() gifFirstStep: boolean = true;

  // @Provide() calibrationDelay: number = 3000; // ms
  // @Provide() calibrationStep: number = 0;
  // @Provide() calibrationProgress: number = 0;

  // @Provide() calibrationWarningTimeout: any;
  // @Provide() calibrationErrorTimeout: any;
  @Provide() alertStationTimeout: any;
  @Provide() updateAllTimer: any;
  // @Provide() calibrationAlert: boolean = false;

  @Provide() currentChangingSole: any = {
    id: '',
    abbr: '',
    pending: {
      dfu: 0,
      calib: {
        left: {
          x: 0,
          y: 0,
          z: 0,
        },
        right: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
    },
    progressing: false,
    completed: true,
    error: false,
    errorCode: null,
  };
  @Provide() steps: any = [
    {
      id: 1,
      name: 'commons.sentences.choose-station',
    },
    {
      id: 2,
      name: 'commons.sentences.update-pairs',
    },
    /*{
      id: 3,
      name: 'commons.sentences.calibrate-pairs',
    },*/
  ];

  get soles() {
    return this.$pdc.entities!.soles.storedEntity.list;
  }
  get solesCheckedBattery() {
    return this.soles.filter((x: any) => x.checked && x.updatable).length;
  }
  get sentencePending() {
    if (this.currentChangingSole.pending.dfu !== 0 && this.currentChangingSole.pending.dfu) {
      switch (true) {
        case this.currentChangingSole.pending.dfu < 50:
          return 'commons.sentences.left-sole';
        case this.currentChangingSole.pending.dfu === 50:
          return 'commons.sentences.sole-change';
        case this.currentChangingSole.pending.dfu > 50 && this.currentChangingSole.pending.dfu < 99:
          return 'commons.sentences.right-sole';
        default:
          return 'commons.standards.finalization';
      }
    } else {
      return 'commons.actions.loading';
    }
  }
  get firstSoleManagment(): boolean {
    return this.$pdc.storage!.getUniversal('firstSoleManagment');
  }
  set firstSoleManagment(value: boolean) {
    this.$pdc.storage!.setUniversal('firstSoleManagment', value);
  }
  get soleCalibProgress() {
    if (this.commandInProgress) {
      let soleProgress = this.currentChangingSole.pending.calib;
      let x = soleProgress.left.x + soleProgress.right.x;
      let y = soleProgress.left.y + soleProgress.right.y;
      let z = soleProgress.left.z + soleProgress.right.z;
      let result = (x + y + z) / 6;
      if (result > 95) result = 95;
      return result;
    } else {
      return 0;
    }
  }
  get stations() {
    return this.$pdc.entities!.stations.storedEntity.list;
  }

  /*@Watch('soleCalibProgress')
  onSoleCalibProgressChange() {
    this.calibrationAlert = false;
  }*/

  // If selected station is disconnected
  @Watch('stations', { deep: true })
  onStationsStatutChange() {
    if (this.selectedStation) {
      this.selectedStation = this.$pdc.entities!.stations.storedEntity.list.find(
        (x: any) => x._id === this.selectedStation._id,
      );
      this.disconnectedStation = !this.selectedStation.online;
    }
  }
  @Watch('selectedStation', { deep: true })
  onSelectedStationChange() {
    this.disconnectedStation = !this.selectedStation.online;
  }

  // Manage gif
  /*@Watch('startCalibration')
  onStartCalibration() {
    this.gifFirstStep = true;
    if (this.startCalibration) {
      setTimeout(() => {
        this.gifFirstStep = false;
      }, 3500);
    }
  }*/

  // Start timer
  /*@Watch('calibrationStep', { deep: true })
  onCalibrationStepChange(val: number) {
    if (val === 2) {
      this.startWarningCalibrationDelay();
      this.startErrorCalibrationDelay();
    }
  }*/

  // Station auto selected
  @Watch('dialog', { deep: true })
  onDialogChange() {
    // IF Acquisition mode - auto select station
    if (this.dialog && this.selectedStationID) {
      this.selectedStation = this.stations.find((x: any) => x._id === this.selectedStationID);
      this.step = 1;
      this.checkBatteries();
    }
    // ELSE
    if (this.dialog && this.selectedStation && !this.selectedStationID) {
      this.step = 0;
      this.checkBatteries();
    }
  }

  setSelectedStation(object: any) {
    this.selectedStation = object.station;
  }

  // CHECK BATTERIES
  async checkBatteries() {
    try {
      this.loading = true;
      this.commandInProgress = true;
      await this.$pdc.entities!.soles.getBatteries();
      setTimeout(() => {
        this.loading = false;
        this.commandInProgress = false;
        if (this.step === 0) this.step = 1;

        // UPDATE calibrateSolesList for next sole calibration
        // this.calibrateSolesList = this.soles.filter((x: any) => !x.calibrated && !x.updatable && x.checked);
      }, 5000);
    } catch (e) {
      // TODO : add error display
      this.loading = false;
      this.commandInProgress = false;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    }
  }

  // UPDATE SOLES
  updateAllSoles() {
    let that = this;

    // Update soles list
    this.updateSolesList = this.soles.filter((x: any) => x.updatable);

    this.commandInProgress = true;
    this.collectiveCommandInProgress = true;

    this.updateAllTimer = setInterval(update, 5000);

    function update() {
      if (!that.updateSolesList || that.updateSolesList.length === 0) {
        that.resetData();
        that.currentChangingSole.id = '';
        that.commandInProgress = false;
        that.collectiveCommandInProgress = false;
        that.currentChangingSole.progressing = false;
        clearInterval(that.updateAllTimer);
      } else {
        for (const sole of that.updateSolesList) {
          if (!that.currentChangingSole.progressing && !that.disconnectedStation && !that.currentChangingSole.error) {
            that.makeSoleDfu(sole._id) /*that.step !== 1 ? that.startSoleCalibration(sole._id)*/;
          }
        }
      }
    }
  }
  makeSoleDfu(id: string) {
    this.resetData();
    this.commandInProgress = true;
    this.currentChangingSole.id = id;
    this.currentChangingSole.abbr = this.soles.find((x: any) => x._id === id)!.abbr;

    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Insole UpgradeStarted', {
      abbr: this.soles.find((x: any) => x._id === id)!.abbr,
    });

    this.$pdc.repository!.socket!.session!.on('commands patched', onCommandPatched);
    const that = this;
    this.startTimeoutErrorStationDFU();

    function onCommandPatched(command: any) {
      that.currentChangingSole.pending.dfu = command.data.progress;
      if (command.status === 'completed') {
        // SUCCESS DFU ------------------------------------
        that.$pdc.repository!.socket!.session!.removeEventListener('commands patched', onCommandPatched);

        that.updateDataComplete();
        that.$store.commit(`pdc/entities/soles/UPDATE`, id);
        that.$pdc.bus!.emit('entities:soles:updated', id);

        // Analytics
        that.$pdc.analytics?.actions.trackSuccess('Insole UpgradeCompleted', {
          abbr: that.soles.find((x: any) => x._id === id)!.abbr,
        });

        console.log(`Soles are updated`, id);
      } else if (command.status === 'error') {
        // ERROR ------------------------------------------
        that.$pdc.repository!.socket!.session!.removeEventListener('commands patched', onCommandPatched);

        that.updateDataError(command);

        // Analytics
        that.$pdc.analytics?.actions.trackFailure('Insole UpgradeCompleted', command.data.error);

        console.log('DFU Error', command.data.error);
      }
    }
    this.$pdc.repository!.emitCommand('update sole dfu', {
      solesId: id,
      stationId: this.selectedStation._id,
    });
  }

  // CALIBRATE SOLES
  /*startSoleCalibration(id: string) {
    this.resetData();
    this.calibrationStep = 0;
    this.commandInProgress = true;
    this.currentChangingSole.id = id;
    this.currentChangingSole.abbr = this.soles.find((x: any) => x._id === id)!.abbr;

    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Insole CalibrationStarted', {
      abbr: this.soles.find((x: any) => x._id === id)!.abbr,
    });

    this.$pdc.repository!.socket!.session!.on('commands patched', onCommandPatched);
    const that = this;
    let connected = false;
    this.startTimeoutErrorStationCalibration();

    function onCommandPatched(command: any) {
      // START CALIBRATION DELAY ---------------------------
      if (command.data.step === 'connected' && !connected) {
        connected = true;
        that.calibrationStep = 1;
        if (that.calibrationStep === 1) that.startTimerDelay();
        setTimeout(() => {
          that.calibrationStep = 2;
        }, that.calibrationDelay);
      }
      // CALIBRATION PENDING -------------------------------
      else if (command.status === 'pending' && command.data.progress) {
        that.currentChangingSole.pending.calib.left = command.data.progress.left;
        that.currentChangingSole.pending.calib.right = command.data.progress.right;
      }
      // CALIBRATION COMPLETED -----------------------------
      else if (command.status === 'completed') {
        that.$pdc.repository!.socket!.session!.removeEventListener('commands patched', onCommandPatched);
        that.calibrationStep = 3;
        that.updateDataComplete();

        // Analytics
        that.$pdc.analytics?.actions.trackSuccess('Insole CalibrationCompleted', {
          abbr: that.soles.find((x: any) => x._id === id)!.abbr,
        });
        console.log(`Soles are calibrate`, id);
      } else if (command.status === 'error') {
        // CALIBRATION ERROR --------------------------------
        that.$pdc.repository!.socket!.session!.removeEventListener('commands patched', onCommandPatched);
        that.updateDataError(command);

        // Analytics
        that.$pdc.analytics?.actions.trackFailure('Insole CalibrationCompleted', command.data.error);
        console.log('CALIBRATION Error', command.data.error);
      }
    }
    this.$pdc.repository!.emitCommand('start soles calibration', {
      solesId: id,
      data: {
        delay: this.calibrationDelay,
      },
      stationId: this.selectedStation._id,
    });
  }*/
  /*openCalibrationWindow(id: string, abbr: string) {
    this.currentChangingSole.id = id;
    this.currentChangingSole.abbr = abbr;
    this.startCalibration = true;
    this.calibrationStep = 0;
  }*/
  /*nextSoleCalibration() {
    let id = this.calibrateSolesList[0]._id;
    let abbr = this.calibrateSolesList[0].abbr;
    this.openCalibrationWindow(id, abbr);
    this.calibrationStep = 0;
    this.startSoleCalibration(this.currentChangingSole.id);
  }*/

  stopCommandInProgress() {
    this.resetData();
    this.currentChangingSole.id = '';
    this.commandInProgress = false;
    this.collectiveCommandInProgress = false;
    this.currentChangingSole.progressing = false;
    clearInterval(this.updateAllTimer);
  }

  // TIMERS
  // TODO find a better solution
  /*startTimerDelay() {
    this.delay = this.calibrationDelay / 1000;

    let that = this;
    let updateTimer = setInterval(update, 1000);

    function update() {
      if (that.delay === 0) {
        clearInterval(updateTimer);
      } else {
        that.delay = that.delay - 1;
      }
    }
  }*/
  startTimeoutErrorStationDFU() {
    this.alertStationTimeout = setTimeout(() => {
      // this.commandInProgress && this.calibrationStep === 0 && this.currentChangingSole.pending.dfu === 0
      if (this.commandInProgress && this.currentChangingSole.pending.dfu === 0) {
        this.currentChangingSole.progressing = false;
        this.currentChangingSole.completed = false;
        this.currentChangingSole.error = true;
        this.currentChangingSole.errorCode = 2007;
        this.currentChangingSole.pending.dfu = 0;
        this.commandInProgress = false;

        // Analytics
        this.$pdc.analytics?.actions.trackFailure('Insole UpgradeStarted', 'timeout');
      } else {
        clearInterval(this.alertStationTimeout);
      }
    }, 15000);
    // !this.commandInProgress || this.calibrationStep !== 0 || this.currentChangingSole.pending.dfu !== 0
    if (!this.commandInProgress || this.currentChangingSole.pending.dfu !== 0) {
      clearInterval(this.alertStationTimeout);
    }
  }
  /*startTimeoutErrorStationCalibration() {
    this.alertStationTimeout = setTimeout(() => {
      if (this.commandInProgress && this.calibrationStep === 0) {
        this.calibrationAlert = true;
        this.currentChangingSole.progressing = false;
        this.commandInProgress = false;

        // Analytics
        this.$pdc.analytics?.actions.trackFailure('Insole CalibrationStarted', 'timeout');
      } else {
        clearInterval(this.alertStationTimeout);
      }
    }, 20000);
    if (!this.commandInProgress || this.calibrationStep !== 0) {
      clearInterval(this.alertStationTimeout);
    }
  }*/
  /*startWarningCalibrationDelay() {
    let lastCalibrationCheck = 0;
    this.calibrationWarningTimeout = setInterval(() => {
      this.calibrationAlert = lastCalibrationCheck === this.soleCalibProgress;
      lastCalibrationCheck = this.soleCalibProgress;
    }, 5000);
  }*/
  /*startErrorCalibrationDelay() {
    this.calibrationErrorTimeout = setTimeout(() => {
      clearInterval(this.calibrationWarningTimeout);
      clearInterval(this.calibrationErrorTimeout);
      clearInterval(this.alertStationTimeout);
      this.currentChangingSole.error = true;
      this.currentChangingSole.errorCode = 1001;
      this.commandInProgress = false;
      this.calibrationAlert = false;

      // Analytics
      this.$pdc.analytics?.actions.trackFailure('Insole CalibrationCompleted', 'timeout');
    }, 35000);
  }*/

  // ACTIONS
  resetData() {
    // this.calibrationAlert = false;
    this.currentChangingSole.error = false;
    this.currentChangingSole.errorCode = null;
    this.currentChangingSole.completed = false;
    this.currentChangingSole.progressing = true;
    this.currentChangingSole.pending.dfu = 0;

    // TODO find a better solution
    this.currentChangingSole.pending.calib.left.x = 0;
    this.currentChangingSole.pending.calib.left.y = 0;
    this.currentChangingSole.pending.calib.left.z = 0;
    this.currentChangingSole.pending.calib.right.x = 0;
    this.currentChangingSole.pending.calib.right.y = 0;
    this.currentChangingSole.pending.calib.right.z = 0;
  }
  updateDataComplete() {
    clearInterval(this.alertStationTimeout);
    // clearInterval(this.calibrationWarningTimeout);
    // clearInterval(this.calibrationErrorTimeout);
    this.commandInProgress = false;
    // this.calibrationAlert = false;
    this.currentChangingSole.completed = true;
    this.currentChangingSole.progressing = false;
    this.updateSolesList = this.updateSolesList.filter((x: any) => x._id !== this.currentChangingSole.id);
    // this.calibrateSolesList = this.calibrateSolesList.filter((x: any) => x._id !== this.currentChangingSole.id);
    this.currentChangingSole.id = '';
  }
  updateDataError(command: any) {
    clearInterval(this.alertStationTimeout);
    // clearInterval(this.calibrationWarningTimeout);
    // clearInterval(this.calibrationErrorTimeout);
    this.currentChangingSole.progressing = false;
    this.currentChangingSole.error = true;
    this.currentChangingSole.errorCode = command.data.error.code;
    this.commandInProgress = false;
    // this.calibrationAlert = false;
  }

  close() {
    this.currentChangingSole.completed = true;
  }
  back() {
    // this.calibrationStep = 0;
    // this.startCalibration = false;
    this.dialog = false;
    this.step = 0;

    this.resetData();
    this.currentChangingSole.progressing = false;
    this.currentChangingSole.id = '';
  }
  backCalibration() {
    // this.startCalibration = false;
    // this.calibrationStep = 0;
    this.resetData();
    this.currentChangingSole.progressing = false;
    this.currentChangingSole.id = '';
  }
  done() {
    if (!this.firstSoleManagment) {
      this.doneComplete = true;
    } else {
      this.back();
    }
  }
  firstSoleManagmentDone() {
    this.firstSoleManagment = true;
    this.doneComplete = false;
    this.back();
  }

  // On dialog form an other place
  open() {
    this.dialog = true;
    if (this.selectedStation) {
      this.step = 1;
    }
  }
  clear() {
    (this.$refs.form as Vue & { reset: () => void }).reset();
    requestAnimationFrame(() => {
      (this.$refs.observer as Vue & { reset: () => void }).reset();
    });
  }

  mounted() {
    this.$pdc.bus!.on('soles:update', this.open);
    // this.calibrateSolesList = this.soles.filter((x: any) => !x.calibrated && !x.updatable);
    this.updateSolesList = this.soles.filter((x: any) => x.updatable);
  }
  beforeDestroy() {
    this.$pdc.bus!.off('soles:update', this.open);
  }
}
